import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import axios from "axios";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../../../Utilitie";
const DateWisePWITOHOReport = () => {
  const [loading, setLoading] = useState(false);
  const [PWIdata, setPWIdata] = useState([]);
  const [error, setError] = useState(false);

  const [selectedRT, setSelectedRT] = useState("Jumbo");
  const tableRef = useRef();
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data: response } = await axios.get(
        `${urlPrefix}getPWIdataDateWise?start=${startDate}&end=${endDate}`
      );

      if (response.status === "ok") {
        setPWIdata(response.daterange);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const jumboData =
    Object.entries(PWIdata).find(
      ([key]) => key.toUpperCase() === "JUMBO"
    )?.[1] || [];

  const boxnData =
    Object.entries(PWIdata).find(
      ([key]) => key.toUpperCase() === "BOXN"
    )?.[1] || [];

  const filteredData =
    selectedRT.toUpperCase() === "JUMBO" ? jumboData : boxnData;

  return (
    <div>
      <div className="papaDiv">
        <div className="d-flex justify-content-between bg-dark text-white p-3 papaDiv">
          <h5 className="">PWI Month Wise Report </h5>
          <div>
            <div className="d-flex  align-items-center ">
              <b>From </b>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="me-1"
              />

              <b>To </b>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
              <button
                className="ms-1 btn btn-sm btn-outline-light"
                onClick={fetchData}
              >
                Fetch
              </button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          {loading && <Loading />}
          <select
            className="form-select form-control text-center fw-bold"
            style={{ maxWidth: "150px" }}
            value={selectedRT}
            onChange={(e) => setSelectedRT(e.target.value)}
          >
            <option value="Jumbo">Jumbo</option>
            <option value="Boxn">Boxn</option>
          </select>
        </div>
        <div
          className="table-responsive table-wrapper"
          style={{ maxHeight: "700px" }}
        >
          {loading && <Loading />}
          <table
            ref={tableRef}
            className="table table-bordered table-striped mb-4 papaDiv"
            style={{ fontSize: "12px" }}
          >
            <thead className="table-dark text-center align-middle    sticky-top">
              <tr>
                <th rowSpan={2}>Sr No. </th>
                <th rowSpan={2}>Date</th>
                <th rowSpan={2}> Section</th>
                <th rowSpan={2}>T/O</th>
                <th rowSpan={2}>H/O</th>
                <th colSpan={2}>T/O</th>
                <th colSpan={2}>H/O</th>
                <th rowSpan={2}>INT</th>
                <th rowSpan={2}>NON-INT</th>
              </tr>
              <tr>
                <th> L</th>
                <th> E</th> <th> L</th>
                <th> E</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center">
                    No data available
                  </td>
                </tr>
              ) : (
                filteredData.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{row.interchange_date.slice(0, 10)}</td>
                    <td>{row.section}</td>

                    <td>{row.to_value}</td>
                    <td>{row.ho_value}</td>
                    <td>{row.to_loaded}</td>
                    <td>{row.to_empty}</td>
                    <td>{row.ho_loaded}</td>
                    <td>{row.ho_empty}</td>
                    <td>{row.to_intensive}</td>
                    <td>{row.to_nonintensive}</td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot className="table-dark sticky-bottom">
              <tr>
                <td colSpan={3} className="text-center">
                  Total
                </td>
                <td rowSpan={2}>
                  {filteredData.reduce(
                    (sum, item) => sum + (item.to_value || 0),
                    0
                  )}
                </td>{" "}
                <td rowSpan={2}>
                  {filteredData.reduce(
                    (sum, item) => sum + (item.ho_value || 0),
                    0
                  )}
                </td>{" "}
                <td rowSpan={2}>
                  {filteredData.reduce(
                    (sum, item) => sum + (item.to_loaded || 0),
                    0
                  )}
                </td>{" "}
                <td rowSpan={2}>
                  {filteredData.reduce(
                    (sum, item) => sum + (item.to_empty || 0),
                    0
                  )}
                </td>{" "}
                <td rowSpan={2}>
                  {filteredData.reduce(
                    (sum, item) => sum + (item.ho_loaded || 0),
                    0
                  )}
                </td>{" "}
                <td rowSpan={2}>
                  {filteredData.reduce(
                    (sum, item) => sum + (item.ho_empty || 0),
                    0
                  )}
                </td>{" "}
                <td rowSpan={2}>
                  {filteredData.reduce(
                    (sum, item) => sum + (item.to_intensive || 0),
                    0
                  )}
                </td>
                <td rowSpan={2}>
                  {filteredData.reduce(
                    (sum, item) => sum + (item.to_nonintensive || 0),
                    0
                  )}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <DownloadExcel
        tableRef={tableRef}
        fileName={`  PWI Month Wise  Report - ${startDate}-${endDate}`}
      />
    </div>
  );
};

export default DateWisePWITOHOReport;
